// extracted by mini-css-extract-plugin
export default {"editor":"lOJzqX5HnxfK6H6uV_gB","root":"KNoTfzg0A0kDQrJ8E9wX"};